<template>
  <div>
    <!--Filters-->
    <b-card no-body>
      <b-card-header class="pb-50">
        <b-row no-gutters class="w-100">
          <b-col>
            <h5>{{ msg("Filters") }}</h5>
          </b-col>
          <b-col>
            <div class="d-flex justify-content-end">
              <b-link style="color: inherit" @click="refresh()">
                <feather-icon icon="RefreshCcwIcon" size="16"/>
              </b-link>
            </div>
          </b-col>
        </b-row>
      </b-card-header>
      <b-card-body>
        <b-row>
          <!--Copied from realEstateContracts.vue-->
          <b-col cols="12" md="4" class="mb-md-0 mb-2">
            <label>{{ msg("name") }}</label>
            <b-form-input size="sm" v-model="filter.name" class="d-inline-block mr-1"/>
          </b-col>
          <b-col cols="12" md="4" class="mb-md-0 mb-2">
            <label>{{ msg("Contact") }}</label>
            <b-form-input size="sm" v-model="filter.contact" class="d-inline-block mr-1"/>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>

    <!--Card Content-->
    <b-card no-body>
      <b-card-header style="overflow: hidden">
        <span class="card-title m-0">{{ msg('Providers') }}</span>
        <b-col>
          <div class="d-flex justify-content-end">
            <b-link style="color: inherit" @click="addNewProvider()">
              <feather-icon icon="PlusIcon" size="16"/>
            </b-link>
          </div>
        </b-col>
      </b-card-header>

      <!--Table-->
      <b-table
          ref="feature-table"
          striped
          hover
          responsive
          v-bind:items="providers"
          v-bind:fields="fields"
          :busy="loading"
          @row-clicked="onRowClick"
      >
        <template #table-busy>
          <div class="text-center text-primary my-2">
            <b-spinner class="align-middle mx-1"></b-spinner>
            <strong>{{ msg('Loading') }}...</strong>
          </div>
        </template>
        <template #cell(creationTime)="data">
          <div>
            {{ $moment(data.value).format('DD/MM/YY HH:mm') }}
          </div>
        </template>
        <template #cell(imageUri)="data">
          <div>
            <b-img :src="data.value" fluid thumbnail style="max-width: 50px; max-height: 50px"/>
          </div>
        </template>
        <template #cell(active)="data">
          <div>
            <b-badge v-if="data.value" variant="success">{{ msg('Active') }}</b-badge>
            <b-badge v-else variant="danger">{{ msg('Inactive') }}</b-badge>
          </div>
        </template>
      </b-table>

      <div class="text-center w-100">
        <div class="d-inline-block">
          <b-pagination
              v-model="page.currentPage"
              :total-rows="page.total"
              :per-page="page.amount"
              first-number
              last-number
              @input="refresh"
          />
        </div>
        <div class="d-inline-block px-2"><strong>{{ msg('Total') }}</strong> {{ page.total }}</div>
      </div>
    </b-card>
    <provider-modal ref="providerModal" @updated="refresh"/>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import ProviderModal from "@/components/modals/providers/ProviderModal.vue";

export default {
  name: "providers",
  components: {ProviderModal},
  data: () => ({
    loading: true,
    filter: {name:null,contact:null},
    providers: [],
    page: {amount: 10, currentPage: 1, total: 0},
  }),
  watch: {
    filter: {
      deep: true,
      handler() {
        this.refresh();
      }
    },
  },
  created() {
    this.refresh();
  },
  computed: {
    ...mapGetters('data', ['getAllBranches']),
    allBranches() {
      return Object.values(this.getAllBranches)
    },
    fields(){
      let $this = this
      return [
        {
          key: 'name',
          label: $this.msg('name'),
          sortable: true
        },
        {
          key: 'description',
          label: $this.msg('description'),
          sortable: false
        }
      ]
    }
  },
  methods: {
    ...mapActions('providers', ['fetchAllProviders']),
    refresh() {
      let $this = this;
      this.loading = true;
      this.fetchAllProviders({
        page: this.page.currentPage,
        amount: this.page.amount,
        filter: this.filter
      }).then(data => {
        console.log("refresh providers", data);
        $this.providers = data.Providers;
        $this.page.amount = data['Amount']
        $this.page.total = data['Total']
        $this.page.currentPage = data['Page']
      }).finally(() => {
        $this.loading = false;
      });
    },
    addNewProvider() {
      this.$refs.providerModal.show();
    },
    onRowClick(provider) {
      this.$refs.providerModal.show(provider.id);
    }
  }
}
</script>


<style scoped>

</style>